import React from 'react';

const Overlay = (props) => (
  <div className="overlay">
    <div className="spinner">{props.LoadingText}</div>
  </div>
);

export default Overlay;
